module.exports = __webpack_public_path__ + "static/media/29EUNOG2.c53a4164.jpg";